/** A lost reply never proves that an account/mailbox mutation failed. */
export function mailResultGuidance(method:string):string {
 return method==='GET'
  ? 'Не удалось загрузить данные почты. Обновите список. Если ошибка повторяется, обратитесь к администратору.'
  : 'Не удалось подтвердить результат действия. Обновите список и проверьте, выполнилось ли оно, прежде чем повторять. Если результат по-прежнему неясен, обратитесь к администратору.';
}
export function mailErrorGuidance(data:unknown,method:string,known:Record<string,string>):string {
 const code=data!==null&&typeof data==='object'&&!Array.isArray(data)?(data as {error?:unknown}).error:undefined;
 return typeof code==='string'&&Object.hasOwn(known,code)?known[code]!:mailResultGuidance(method);
}
